<template>
  <div
    v-if="!!footnotes.length"
    class="emh-local-footnote-container wb-new-colors emh-local-footnote-container__inner-wrapper"
  >
    <ul class="emh-local-footnote-container__list">
      <li v-for="item in footnotes" :key="item.referenceNumber" class="emh-local-footnote-container__item">
        <span v-if="!!item.referenceNumber">{{ `[${item.referenceNumber}]` }}&nbsp;</span>
        <span :innerHTML="item.text"></span>
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
export default {
  name: 'LocalFootnoteContainer',
};
</script>

<script setup lang="ts">
import { computed } from 'vue';
import { useLocalFootnotesStore } from '../../stores/localFootnotes/local-footnotes.composable';
import type { FootnoteItem } from '../../stores/localFootnotes/local-footnotes.types';

export interface LocalFootnoteContainer {
  context?: string;
}

const props = withDefaults(defineProps<LocalFootnoteContainer>(), {
  context: 'default',
});

const { state: localFootnoteState } = useLocalFootnotesStore();
const footnotes = computed<FootnoteItem[]>(() =>
  localFootnoteState.contexts[props.context] ? [...localFootnoteState.contexts[props.context]] : [],
);
</script>

<style scoped lang="scss" src="./localFootnoteContainer.scss" />
